var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6982 12.529C12.3816 11.8456 13.4897 11.8456 14.1731 12.529L43.8717 42.2275C44.5551 42.9109 44.5551 44.0189 43.8717 44.7023C43.1882 45.3858 42.0802 45.3858 41.3968 44.7024L11.6982 15.0039C11.0148 14.3205 11.0148 13.2125 11.6982 12.529Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1855 13.7665C11.1855 12.8 11.969 12.0165 12.9355 12.0165H33.9355C34.902 12.0165 35.6855 12.8 35.6855 13.7665C35.6855 14.733 34.902 15.5165 33.9355 15.5165H14.6855V34.7665C14.6855 35.733 13.902 36.5165 12.9355 36.5165C11.969 36.5165 11.1855 35.733 11.1855 34.7665V13.7665Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftUp);
export default __webpack_public_path__ + "static/media/arrow-left-up.3ad248a1.svg";
export { ForwardRef as ReactComponent };